import ContentfulParser from 'utils/contentfulParser/contents'

const toPath = value => {
  if (typeof value !== 'string') {
    return ''
  }

  const path = value
    .trim()
    .split('#')[0]
    .split('?')[0]
  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path
}

/**
 * Activity breadcrumbs include the list page itself. Drop that link when the
 * list page is the current page, so it does not show up as an extra crumb.
 */
const withoutCurrentPage = (breadcrumb, pathname) => {
  const currentPath = toPath(pathname)
  if (!breadcrumb?.route?.length || !currentPath) {
    return breadcrumb
  }

  const route = breadcrumb.route.filter(
    link => toPath(link?.url) !== currentPath,
  )

  if (route.length === breadcrumb.route.length) {
    return breadcrumb
  }

  return route.length ? { ...breadcrumb, route } : undefined
}

export const getBreadcrumb = ({ activityList, groupedContent, pathname }) => {
  const pageBreadcrumb = activityList?.breadcrumb ?? groupedContent?.breadcrumb

  if (pageBreadcrumb?.route?.length) {
    return withoutCurrentPage(pageBreadcrumb, pathname)
  }

  const childBreadcrumb = groupedContent?.content?.find(
    content => content?.breadcrumb?.route?.length,
  )?.breadcrumb

  return withoutCurrentPage(childBreadcrumb, pathname)
}

export const formContentCardList = (entry, path) => {
  const { tabSummaries: parentListContent = [] } = entry || {}

  const contentTypes = []

  parentListContent.forEach(contentGroup => {
    const { route, displayTitle } = contentGroup || {}

    if (displayTitle && route) {
      contentTypes.push({
        title: displayTitle,
        route,
      })
    }
  })

  const activeContentType = contentTypes.find(contentGroup => {
    const { route } = contentGroup || {}

    return route === path
  })

  if (!activeContentType) {
    return null
  }

  return {
    contentTypes,
    activeContent: entry,
    activeContentType,
  }
}

export const getVideoData = entry => {
  const { content } = entry || {}
  const videoEntry = !!content && content?.find(e => e.contentType === 'Video')
  const video = ContentfulParser.video(videoEntry)

  const { displayTitle, time, videoUrl, videoThumbnailUrl, tracks, id } =
    video || {}
  const videoData = {
    videoDisplayTitle: displayTitle,
    videoLength: time,
    tracks,
    videoThumbnailUrl,
    videoUrl,
    videoId: id,
  }
  return videoData
}

export const getListProps = entry => {
  const { content } = entry || {}
  const categoryEntry =
    !!content && content.find(e => e.contentType === 'Category')
  const { displayTitle, assets = [], id } = categoryEntry || {}
  const links = assets.map(asset => {
    const {
      displayTitle,
      url,
      contentType: contentTypeWrapper,
      file: fileWrapper,
    } = asset || {}
    const { file, url: url2 } = fileWrapper || {}
    const { url: fileUrl } = file || {}
    const { id: contentType } = contentTypeWrapper || {}
    // file type contentType (i.e. PDFs) links have a fileUrl, so url will be on this level of the asset
    const href = fileUrl || url || url2

    return {
      text: displayTitle,
      href,
      contentType: contentType || contentTypeWrapper?.toLowerCase(),
    }
  })

  return {
    header: displayTitle,
    id,
    links,
  }
}
